export const localStorageConst = {
  UserName: "username",
  Password: "password",
  PhoneNumber: "phoneNumber",
  IsSignClicked: "isSignClicked",
  IsDeleteSignClicked: "isDeleteSignClicked",
};

export const ErrorDefinition = {
  SingInErrorCode: "UserNotConfirmedException",
  ChangeEmailError: "Ett konto med e-postadressen finns redan.",
  ConfirmAttributeCodeError:
    "Ogiltig verifieringskod har angetts, försök igen.",
};

export const BooleanDefinition = {
  True: "true",
  False: "false",
};

export const SuccessMessage = {
  Success: "success",
  UserDelete: "Ditt konto raderat.",
};
